import { YoutubePlayer } from './youtube-player';

YoutubePlayer.init();
